<div class="layout-footer">
    <div class="grid p-0 m-0" style="width: 100%">
        <div class="col-4"><img src="assets/layout/images/{{layoutService.config.colorScheme === 'light' ? 'logo-dark' : 'logo-white'}}.png" alt="Logo" height="25" class="mr-2"/></div>
        <div class="col-6">Todos os direitos reservados &copy; <a href="http://infoaries.com.br">Infoáries - Aerosys</a></div>
        <div class="col-2">Version: 1.0.0</div>
    </div>
</div>
